import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import { useTranslate } from "@tolgee/react";

const UnsavedChangesDialog = ({ 
  open, 
  onClose, 
  onSave, 
  onDiscard,
  title,
  message 
}) => {
  const { t } = useTranslate();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="unsaved-changes-dialog-title"
      aria-describedby="unsaved-changes-dialog-description"
    >
      <DialogTitle id="unsaved-changes-dialog-title">
        {title || t('general.warning')}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="unsaved-changes-dialog-description">
          {message || t('conferences.unsaved_changes_message')}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onDiscard} color="error">
          {t('general.no')}
        </Button>
        <Button onClick={onSave} autoFocus variant="contained" color="primary">
          {t('general.yes')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UnsavedChangesDialog;